import { inject, Injectable, OnDestroy } from '@angular/core';
import { WorkMegasearchResultDto, WorkSearchCategoryEnum, WorkSearchV2Service } from '@work-frontend-monorepo/work-rest-api';
import { Subject, switchMap, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MegasearchService implements OnDestroy {
  private readonly workSearchV2Service = inject(WorkSearchV2Service);
  private stopRequest$ = new Subject<void>();
  private searchSubject = new Subject<{ text: string, categories: WorkSearchCategoryEnum[] | undefined, projectsSoldTrue?: boolean }>();

  public doSearch(text: string, categories: WorkSearchCategoryEnum[] | undefined, projectsSoldTrue?: boolean): Promise<WorkMegasearchResultDto> {
    return new Promise((resolve, reject) => {
      this.cancelExistingSearch();
      this.initializeSearchSubject(resolve, reject);
      this.searchSubject.next({ text, categories, projectsSoldTrue });
    });
  }

  public cancelExistingSearch(): void {
    this.stopRequest$.next();
    if (this.searchSubject) {
      this.searchSubject.unsubscribe();
    }
    // todo: stop the api - https://www.notion.so/digitalemenschen/Office-Megasearch-cancel-request-2bc4c890c93380249c30f1c379b0adfd
  }

  private initializeSearchSubject(
    resolve: (value: WorkMegasearchResultDto) => void,
    reject: (reason?: never) => void,
  ): void {
    this.searchSubject = new Subject();

    this.searchSubject
      .pipe(
        switchMap((params) => this.executeSearch(params)),
        takeUntil(this.stopRequest$),
      )
      .subscribe({
        next: resolve,
        error: reject,
        complete: () => {
          this.searchSubject.unsubscribe();
        },
      });
  }

  private executeSearch(params: { text: string; categories: WorkSearchCategoryEnum[] | undefined; projectsSoldTrue?: boolean }) {
    const { text, categories, projectsSoldTrue } = params;
    return this.workSearchV2Service.searchV2ControllerMegasearchBySearchterm({
      searchterm: text,
      searchCategories: categories,
      projectsSoldTrue,
    });
  }

  ngOnDestroy() {
    this.searchSubject.unsubscribe();
    this.stopRequest$.next();
    this.stopRequest$.unsubscribe();
  }
}
